var $ = global.jQuery = global.$;
var GoogleMapsLoader = require('google-maps');
var MarkerClusterer = require('marker-clusterer-plus');

var mapConfig = require('../config').maps;

var _Base = require('./_Base');

/**
 * Starting point Google Map Class
 * @class
 * @extends _Base
 */
var _Map = _Base.extend(
  /** @lends _Map.prototype */
  {
  /**
   * Initialises the map
   * @private
   */
  init: function() {
    var self = this;

    this.mapOptions = this.mapOptions ? $.extend(this.mapOptions, mapConfig.defaults) : mapConfig.defaults;

    this.markerStyles = this.markerStyles ? $.extend(this.markerStyles, mapConfig.markers) : mapConfig.markers;

    GoogleMapsLoader.KEY = mapConfig.api.KEY;
    GoogleMapsLoader.LIBRARIES = mapConfig.api.LIBRARIES;

    GoogleMapsLoader.load(function(google) {
      self.google = google;
      self.map = new google.maps.Map(self.$el.get(0), self.mapOptions);
      self.cluster = new MarkerClusterer(self.map, [], self.markerStyles);

      self.map.setCenter(new google.maps.LatLng(0, 0));

      self.$el.trigger('Map:loaded');

      if (typeof(self.onMapLoaded) === 'function') {
        self.onMapLoaded(google);
      }

      $(window).on('resize orientationchange', function() {
        self.redraw();
      });
    });

  },
  /**
   * Creates a new Google maps Marker
   * @param {number} lat Latitude
   * @param {number} lng Longitude
   * @param {object} opts Additional options to pass to the new marker
   * @returns {Marker} a new Marker() instance
   */
  createMarker: function(lat, lng, opts) {
    var options = opts ? opts : {};
    options.optimized = false; //This is because IE sucks so we can't have nice things
    options.position = new this.google.maps.LatLng(lat, lng);
    if (this.defaultIcon) options.icon = this.defaultIcon;

    return new this.google.maps.Marker(options);
  },
  /**
   * Redraws the map
   */
  redraw: function() {
    this.cluster.fitMapToMarkers();
    this.google.maps.event.trigger(this.map, 'resize');
  },
  /**
   * Adds new markers to the map
   * @param {Array} markers Array of markers to add
   * @param {boolean} [clustered] Pass true to cluster the markers, otherwise markers will appear individually
   */
  addMarkers: function(markers, clustered) {
    var self = this;

    if (clustered) {
      this.cluster.addMarkers(markers);
    } else {
      $.each(markers, function() {
        this.setMap(self.map);
      });
    }
  }
});

module.exports = _Map;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/_Map.js
 ** module id = 154
 ** module chunks = 0 1
 **/